import experimentSingleton from '../vendor/experiment.vendor'

export const CHAT_TWILIO_CONVERSATIONS_ROLLOUT_FLAGS = {
  ChatTwilioConversationsEnable: 'cj-core-feature-twilio-conversations-3-x'
}

async function isChatTwilioConversationsFlagEnabled () {
  return await experimentSingleton.isFlagActive(
    CHAT_TWILIO_CONVERSATIONS_ROLLOUT_FLAGS.ChatTwilioConversationsEnable
  )
}

export { isChatTwilioConversationsFlagEnabled }
